import React, { useEffect, useState } from 'react';
import { Chevron } from '../SVGs';

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      setShowButton(scrollY >= viewportHeight);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {showButton && (
        <button
          className="sticky top-11/12 self-start hidden tablet:flex flex-col gap-16 cursor-pointer p-8"
          onClick={scrollToTop}
          aria-label="Scroll til toppen"
        >
          <Chevron />
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
